export default __webpack_public_path__ + "static/media/IMG_1195.01458974.jpg";